import classNames from 'classnames';
import { useRouter } from 'next/router';
import React from 'react';
import { SiImdb } from 'react-icons/si';
import { useEntity } from '../../../../lib/entity';
import slugify from '../../../../lib/utils/slugify';
import { IconButton } from '../../../Button';
import Details from './Details';
import EntityDescription from './EntityDescription';

export default function EntityDetails() {
  const router = useRouter();
  const { type } = router.query;
  const entity = useEntity().entity;
  const entityDetails = entity[`${type}_details`];

  if (!entityDetails) {
    return null;
  }

  const detailsClasses = classNames('feed main-enttity-content');
  return (
    <section className={detailsClasses}>
      <section>
        <section className="relative">
          <IconButton
            as="a"
            href={entity.main_url}
            target="_blank"
            rel="noreferrer noopenner"
            className="source-link"
          >
            <SiImdb className="icon" />
          </IconButton>
        </section>
        <section className="flex flex-col mb-10 space-y-8">
          {Object.entries(entityDetails)
            .filter(([key]) => !['descriptions', 'storyline', 'tagline'].includes(key))
            .map(([key, value]) => {
              const getAttribute = () => {
                if (['directors', 'cast', 'movies', 'directed', 'produced'].includes(key)) {
                  const entityType = ['cast', 'directors'].includes(key) ? 'person' : 'title';
                  return value.map((i) => ({
                    ...i,
                    href: `/e/${entityType}/${slugify(i.name)}-${i.id}`,
                  }));
                }

                return value.map((i, index) => ({
                  id: index,
                  name: i,
                }));
              };

              const attribute = getAttribute();

              if (!attribute.length) {
                return null;
              }

              return <Details key={key} title={key} attribute={attribute} />;
            })}
        </section>
        {!!entityDetails.descriptions.length && (
          <section>
            <h3 className="font-bold text-lg">Description</h3>
            <section className="space-y-4">
              {entityDetails.descriptions.map((text) => (
                <EntityDescription key={text} text={text} />
              ))}
            </section>
          </section>
        )}
      </section>
    </section>
  );
}
